import Crud from '@/stores/crudBase';
import api from '@/apis/opening/openingSupplyEntryAPI.js';
var crud = new Crud('openingSupplyEntry', api);

const state = {
  ...crud.state,
  _config: {
    table: 'opening_supply_entry',
    field: {
      key: 'ref_id',
      code: 'inventory_item_code',
      name: 'inventory_item_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  importOpeningSupplyEntry(context, sessionId) {
    api.importOpeningSupplyEntry(sessionId);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
